<!-- Fields Items -->
<div *ngIf="fieldType === fieldTypes.FIELD && customFieldData?.length">
    <ng-container *ngFor="let field of customFieldData">
        <ng-container [ngSwitch]="field.formControl.name">
            <ng-container *ngSwitchCase="'InputBox'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{ field?.value }}</span>
                </p>
            </ng-container>
            <ng-container *ngSwitchCase="'Decimal'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{ field?.value }}</span>
                </p>
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{ field?.value }}</span>
                </p>
            </ng-container>
            <ng-container *ngSwitchCase="'DropDownList'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{ field?.value?.name }}</span>
                </p>
            </ng-container>
            <ng-container *ngSwitchCase="'ToggleButton'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{ field?.value }}</span>
                </p>
            </ng-container>
            <ng-container *ngSwitchCase="'RadioButton'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{ field?.value }}</span>
                </p>
            </ng-container>
            <ng-container *ngSwitchCase="'Rating'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{ field?.value }}</span>
                </p>
            </ng-container>
            <ng-container *ngSwitchCase="'Picture'">
                <div *ngIf="
                        field.customUploadedFiles &&
                        field.customUploadedFiles.length > 0
                    ">
                    <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                        {{ field.name }}:<span>{{
                            pic?.name
                            }}</span>
                    </p>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'MultipleDropDownList'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{ getFormattedData(field) }}</span>
                </p>
            </ng-container>
            <ng-container *ngSwitchCase="'CheckBox'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{
                        field?.value && field?.value.length > 0
                        ? field?.value?.join(', ')
                        : ""
                        }}</span>
                </p>
            </ng-container>

            <ng-container *ngSwitchCase="'DatePicker'">
                <p class="p-mb-0">
                    {{ field.name }}:
                    <span>{{ field?.value }}</span>
                </p>
            </ng-container>
            <ng-container *ngSwitchCase="'FileUpload'">
                <div *ngIf="field.customUploadedFiles && field.customUploadedFiles.length > 0">
                    <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                        {{ field.name }}:<span>{{pic?.name}}</span>
                    </p>
                </div>
            </ng-container>
            <ng-container *ngSwitchDefault> </ng-container>
        </ng-container>
    </ng-container>
</div>

<!-- Section Item -->
<div *ngIf="fieldType === fieldTypes.SECTION && customFieldData?.length">
    <div class="p-col" *ngFor="let field of customFieldData">
        <div class="card">
            <ng-container [ngSwitch]="field.formControl.name">
                <ng-container *ngSwitchCase="'InputBox'">
                    <h6 class="p-mb-0">
                        {{ field?.name }}
                    </h6>
                    <p class="p-mb-0">
                        {{ field?.value }}
                    </p>
                </ng-container>
                <ng-container *ngSwitchCase="'DropDownList'">
                    <h6 class="p-mb-0">
                        {{ field?.name }}
                    </h6>
                    <p class="p-mb-0">
                        {{ field?.value?.name }}
                    </p>
                </ng-container>
                <ng-container *ngSwitchCase="'ToggleButton'">
                    <h6 class="p-mb-0">
                        {{ field?.name }}
                    </h6>
                    <p class="p-mb-0">
                        {{ field?.value }}
                    </p>
                </ng-container>
                <ng-container *ngSwitchCase="'RadioButton'">
                    <h6 class="p-mb-0">
                        {{ field?.name }}
                    </h6>
                    <p class="p-mb-0">
                        {{ field?.value }}
                    </p>
                </ng-container>
                <ng-container *ngSwitchCase="'Rating'">
                    <h6 class="p-mb-0">
                        {{ field?.name }}
                    </h6>
                    <p class="p-mb-0">
                        {{ field?.value }}
                    </p>
                </ng-container>
                <ng-container *ngSwitchCase="'Picture'">
                    <div *ngIf="
                            field.customUploadedFiles &&
                            field.customUploadedFiles.length > 0
                        ">
                        <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                            {{ field.name }}:<span>{{ pic?.name }}</span>
                        </p>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'MultipleDropDownList'">
                    <p class="p-mb-0">
                        {{ field.name }}:
                        <span>{{ getFormattedData(field) }}</span>
                    </p>
                </ng-container>
                <ng-container *ngSwitchCase="'CheckBox'">
                    <p class="p-mb-0">
                        {{ field.name }}:
                        <span>{{
                            field?.value && field?.value.length > 0
                            ? field?.value?.join(', ')
                            : ""
                            }}</span>
                    </p>
                </ng-container>

                <ng-container *ngSwitchCase="'DatePicker'">
                    <h6 class="p-mb-0">
                        {{ field?.name }}
                    </h6>
                    <p class="p-mb-0">
                        {{ field?.value }}
                    </p>
                </ng-container>
                <ng-container *ngSwitchCase="'FileUpload'">
                    <div *ngIf="
                    field.customUploadedFiles &&
                    field.customUploadedFiles.length > 0
                ">
                <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                    {{ field.name }}:<span>{{
                        pic?.name
                        }}</span>
                </p>
            </div>
                </ng-container>
                <ng-container *ngSwitchDefault> </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<!-- Footer Item -->
<div *ngIf="fieldType === fieldTypes.FOOTER && customFieldData">
    <ng-container [ngSwitch]="
            customFieldData.formControl
             .name
            ">
        <ng-container *ngSwitchCase="'InputBox'">
            <p class="p-mb-0">
                {{
                customFieldData?.name
                }}:
                <span>{{
                    customFieldData?.value
                    }}</span>
            </p>
        </ng-container>
        <ng-container *ngSwitchCase="'DropDownList'">
            <p class="p-mb-0">
                {{ customFieldData.name }}:
                <span>{{
                    customFieldData?.value
                    ?.name
                    }}</span>
            </p>
        </ng-container>
        <ng-container *ngSwitchCase="'ToggleButton'">
            <p class="p-mb-0">
                {{ customFieldData.name }}:
                <span>{{
                    customFieldData?.value
                    }}</span>
            </p>
        </ng-container>
        <ng-container *ngSwitchCase="'RadioButton'">
            <p class="p-mb-0">
                {{ customFieldData.name }}:
                <span>{{
                    customFieldData?.value
                    }}</span>
            </p>
        </ng-container>
        <ng-container *ngSwitchCase="'Rating'">
            <p class="p-mb-0">
                {{ customFieldData.name }}:
                <span>{{
                    customFieldData?.value
                    }}</span>
            </p>
        </ng-container>
        <ng-container *ngSwitchCase="'Picture'">
            <div *ngIf="
                 customFieldData
                     .customUploadedFiles &&
                 customFieldData
                     .customUploadedFiles.length > 0
             ">
                <p class="p-mb-0" *ngFor="
                     let pic of customFields
                         ?.footer_item[0]
                         .customUploadedFiles
                 ">
                    {{
                    customFieldData
                    .name
                    }}:<span>{{ pic?.name }}</span>
                </p>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'MultipleDropDownList'">
            <p class="p-mb-0">
                {{
                customFieldData?.name
                }}:
                <span>{{
                    getFormattedData(
                    customFieldData
                    )
                    }}</span>
            </p>
        </ng-container>
        <ng-container *ngSwitchCase="'CheckBox'">
            <p class="p-mb-0">
                {{
                customFieldData?.name
                }}:
                <span>{{
                    customFieldData
                    ?.value &&
                    customFieldData?.value
                    .length > 0
                    ? customFieldData
                    ?.value[0]
                    : ""
                    }}</span>
            </p>
        </ng-container>

        <ng-container *ngSwitchCase="'DatePicker'">
            <p class="p-mb-0">
                {{
                customFieldData?.name
                }}:
                <span>{{
                    customFieldData?.value
                    }}</span>
            </p>
        </ng-container>
        <ng-container *ngSwitchCase="'FileUpload'">
            <p class="p-mb-0">
                {{
                customFieldData?.name
                }}:
                <span>{{
                    customFieldData?.value
                    }}</span>
            </p>
        </ng-container>
        <ng-container *ngSwitchDefault> </ng-container>
    </ng-container>
</div>
